module.exports = __webpack_public_path__ + "static/media/red-dot.ba36b4cf.svg";